var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWrapDotGiftsCorporateMark = function SvgWrapDotGiftsCorporateMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "wrapDotGiftsCorporateMark_svg__Layer_1",
    viewBox: "102 136 396 396"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".wrapDotGiftsCorporateMark_svg__cls-5{stroke-width:0;fill:#ec4646}"))), /*#__PURE__*/React.createElement("path", {
    d: "M164.23 513.81c-10.46 0-18.97-8.51-18.97-18.97V303.06h309.49v191.78c0 10.46-8.51 18.97-18.97 18.97H164.23Z",
    style: {
      fill: "#8dacfb",
      strokeWidth: 0
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M452.75 305.06v189.78c0 9.37-7.6 16.97-16.97 16.97H164.22c-9.37 0-16.97-7.6-16.97-16.97V305.06h305.49m4-4H143.25v193.78c0 11.56 9.41 20.97 20.97 20.97h271.55c11.56 0 20.97-9.41 20.97-20.97V301.06Z",
    className: "wrapDotGiftsCorporateMark_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M255.58 309.22h88.86V513.8h-88.86z",
    style: {
      strokeWidth: 0,
      fill: "#cb595a"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M342.44 311.22V511.8h-84.86V311.22h84.86m4-4h-92.86V515.8h92.86V307.22Z",
    className: "wrapDotGiftsCorporateMark_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M146.27 313.22c-5.45 0-9.88-4.7-9.88-10.49v-84.86c0-5.78 4.43-10.49 9.88-10.49h307.46c5.45 0 9.88 4.7 9.88 10.49v84.86c0 5.78-4.43 10.49-9.88 10.49H146.27Z",
    style: {
      fill: "#b5c9ff",
      strokeWidth: 0
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M453.73 209.39c4.35 0 7.88 3.8 7.88 8.49v84.86c0 4.69-3.53 8.49-7.88 8.49H146.27c-4.35 0-7.88-3.8-7.88-8.49v-84.86c0-4.69 3.53-8.49 7.88-8.49h307.47m0-4H146.27c-6.55 0-11.88 5.6-11.88 12.49v84.86c0 6.88 5.33 12.49 11.88 12.49h307.47c6.55 0 11.88-5.6 11.88-12.49v-84.86c0-6.88-5.33-12.49-11.88-12.49Z",
    className: "wrapDotGiftsCorporateMark_svg__cls-5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M423.06 175.45c0 11.71-17.03 33.08-23.5 33.94-31.66 4.24 2.28-17.99 2.28-29.7s-9.31-24.29-2.28-24.29 23.5 8.32 23.5 20.04Z",
    className: "wrapDotGiftsCorporateMark_svg__cls-5",
    vectorEffect: "non-scaling-stroke"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M406.05 158.48c28.49 24.35 0 29.7-4.24 16.97-4.69-14.09-67.89 29.7-67.89 16.97 0-7.03 27.37-24.3 38.19-29.7 8.49-4.24 33.94-11.28 33.94-4.24Zm-1.89 36.56c10.38-6.86 6.14 10.12-10.84 14.36-21.09 0-50.92 2.34-50.92 0-4.24-8.49 23.68-10.12 44.78-10.12 16.97-5.69 6.14-2.61 16.97-4.24Zm-231.47-19.59c0 11.71 17.03 33.08 23.5 33.94 31.65 4.24-2.28-17.99-2.28-29.7s9.31-24.29 2.28-24.29-23.5 8.32-23.5 20.04Z",
    className: "wrapDotGiftsCorporateMark_svg__cls-5",
    vectorEffect: "non-scaling-stroke"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M189.71 158.43c-28.49 24.35 0 29.7 4.24 16.97 4.69-14.09 67.89 29.7 67.89 16.97 0-7.03-27.37-24.3-38.19-29.7-8.49-4.24-33.94-11.28-33.94-4.24Zm1.89 36.56c-10.38-6.86-6.14 10.12 10.84 14.36 21.09 0 50.92 2.34 50.92 0 4.24-8.49-23.68-10.12-44.78-10.12-16.97-5.69-6.14-2.61-16.97-4.24Z",
    className: "wrapDotGiftsCorporateMark_svg__cls-5",
    vectorEffect: "non-scaling-stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M350.92 209.49H249.09c0-18.81 22.79-34.06 50.92-34.06s50.92 15.25 50.92 34.06Z",
    className: "wrapDotGiftsCorporateMark_svg__cls-5",
    vectorEffect: "non-scaling-stroke"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.09 207.39h105.83v105.83H247.09z",
    style: {
      fill: "#f38181",
      strokeWidth: 0
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M350.92 209.39v101.83H249.09V209.39h101.83m4-4H245.09v109.83h109.83V205.39Z",
    className: "wrapDotGiftsCorporateMark_svg__cls-5"
  })));
};
export default SvgWrapDotGiftsCorporateMark;